import { fruitLabel } from "@/data/fruits";
import { formatStoredDate } from "@/lib/date";

const formatHistoryDate = (date) =>
  formatStoredDate(date, {
    weekday: "long",
    month: "long",
    day: "numeric",
  });

export const HistoryItem = ({ item, index }) => (
  <article
    className="gentle-reveal rounded-2xl border border-[#E5E1D8] bg-white p-5 shadow-[0_8px_30px_rgba(26,54,38,0.04)] sm:p-7"
    data-testid={`history-item-${item.id}`}
    style={{ animationDelay: `${index * 45}ms` }}
  >
    <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div data-testid={`history-item-${item.id}-header`}>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#8C9B90]" data-testid={`history-item-${item.id}-period`}>{item.period}</p>
        <h2 className="mt-1 font-serif-display text-3xl font-semibold text-[#1A3626]" data-testid={`history-item-${item.id}-date`}>{formatHistoryDate(item.reflection_date)}</h2>
      </div>
      <div className="rounded-xl bg-[#F9F6F0] px-5 py-3 text-right" data-testid={`history-item-${item.id}-average-card`}>
        <p className="text-xs uppercase tracking-[0.2em] text-[#8C9B90]" data-testid={`history-item-${item.id}-average-label`}>Average</p>
        <p className="font-serif-display text-3xl font-semibold text-[#1A3626]" data-testid={`history-item-${item.id}-average`}>{item.average_score.toFixed(2)}</p>
      </div>
    </div>
    <div className="mt-6 grid gap-2 sm:grid-cols-3" data-testid={`history-item-${item.id}-ratings`}>
      {Object.entries(item.ratings).map(([fruit, score]) => (
        <div key={fruit} className="flex items-center justify-between rounded-xl border border-[#E5E1D8] bg-[#F9F6F0] px-3 py-2" data-testid={`history-item-${item.id}-${fruit}-rating`}>
          <span className="text-sm text-[#4A5D4E]" data-testid={`history-item-${item.id}-${fruit}-label`}>{fruitLabel(fruit)}</span>
          <span className="font-semibold text-[#1A3626]" data-testid={`history-item-${item.id}-${fruit}-score`}>{score}/5</span>
        </div>
      ))}
    </div>
    {(item.prompt_response || item.notes) && (
      <div className="mt-6 grid gap-4 lg:grid-cols-2" data-testid={`history-item-${item.id}-notes-grid`}>
        {item.prompt_response && <p className="rounded-xl bg-[#F9F6F0] p-4 text-sm leading-relaxed text-[#4A5D4E]" data-testid={`history-item-${item.id}-prompt-response`}>{item.prompt_response}</p>}
        {item.notes && <p className="rounded-xl bg-[#F9F6F0] p-4 text-sm leading-relaxed text-[#4A5D4E]" data-testid={`history-item-${item.id}-notes`}>{item.notes}</p>}
      </div>
    )}
    {item.monthly_summary && (
      <div className="mt-6 rounded-xl border border-[#E5E1D8] bg-[#F9F6F0] p-4" data-testid={`history-item-${item.id}-monthly-summary`}>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#8C9B90]" data-testid={`history-item-${item.id}-monthly-summary-label`}>Monthly review</p>
        <p className="mt-2 text-sm leading-relaxed text-[#4A5D4E]" data-testid={`history-item-${item.id}-monthly-summary-text`}>{item.monthly_summary}</p>
      </div>
    )}
  </article>
);